import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-brand-yellow bg-brand-night" data-id="element-116" data-mp="ddvgdgeskhf3">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-117" data-mp="icowlglgqmiy">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-brand-yellow" data-id="element-118" data-mp="mds8js0e3yew">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-1.5 font-display text-base font-extrabold leading-tight text-white sm:text-xl" data-id="element-119" data-mp="wcr6afjma9n4">
          Comienza hoy y organiza Matemática de 1.º año con una ruta completa.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-xl border-4 border-dashed border-brand-yellow bg-white text-brand-navy" data-id="element-120" data-mp="2y4w76gj3gh9z">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-121" data-mp="12pczb2yiu9z5">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-122" data-mp="xupaf2zlvdk1" />
          </a>
          <div className="p-3" data-id="element-123" data-mp="ou0shx73ct1v">
            <p className="font-display text-[0.8rem] font-black uppercase leading-tight text-brand-blue sm:text-sm" data-id="element-124" data-mp="1lm4ccungzsur">
              {PRODUCT_NAME}
            </p>
            <p className="mt-0.5 font-display text-lg font-black uppercase tracking-wide" data-id="element-125" data-mp="1go2yco4wijq5">
              6 Tomos + 5 Bonos
            </p>
            <p className="text-[0.75rem] text-slate-700" data-id="element-126" data-mp="17mv6ooww4h51">
              🎁 Bonos valorados en{' '}
              <span className="font-semibold text-red-600 line-through" data-id="element-127" data-mp="169dumy2w3xf">
                {BONUS_VALUE}
              </span>
            </p>

            <p className="mt-1.5 inline-block rounded bg-red-600 px-2.5 py-0.5 font-display text-[0.62rem] font-black uppercase tracking-wide text-white" data-id="element-128" data-mp="3sb97m9afpesw">
              🔥 Oferta especial
            </p>

            <p className="mt-1 font-display text-5xl font-black leading-none tracking-tight text-brand-blue sm:text-6xl" data-id="element-129" data-mp="2n6iqht3h98l">
              <span className="font-hand text-4xl font-bold text-brand-navy sm:text-5xl" data-id="element-130" data-mp="3kvnsxij408k5">
                Hoy:
              </span>{' '}
              {PRICE}
            </p>
            <p className="mt-1 text-[0.7rem] font-medium text-slate-700" data-id="element-131" data-mp="3b1x9is1uaobb">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-132" data-mp="315lptgzx6w6u">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>

            <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-medium text-slate-700" data-id="element-133" data-mp="362c9eeaxo9x0">
              <span className="flex items-center gap-1" data-id="element-134" data-mp="2x48lxcge132k">
                <ZapIcon size={12} className="text-brand-orange" data-id="element-135" data-mp="2x5th94aj0q1h" />
                Acceso Inmediato
              </span>
              <span className="text-slate-400" data-id="element-136" data-mp="28iu5bk22d9gz">•</span>
              <span className="flex items-center gap-1" data-id="element-137" data-mp="28k5i29dhlrk8">
                <ShieldCheckIcon size={12} className="text-brand-blue" data-id="element-138" data-mp="2midf0haiwsve" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}